import { useEffect } from "react";

function upsertMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export default function Seo({ title, siteName, description, image, jsonLd }) {
  useEffect(() => {
    const url = window.location.origin + window.location.pathname;

    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", url);

    if (title) document.title = title;
    upsertMeta("name", "description", description);
    upsertMeta("property", "og:url", url);
    upsertMeta("property", "og:title", title);
    upsertMeta("property", "og:description", description);
    upsertMeta("property", "og:site_name", siteName);
    upsertMeta("property", "og:type", "website");
    if (image) upsertMeta("property", "og:image", window.location.origin + image);
    upsertMeta("name", "twitter:card", image ? "summary_large_image" : "summary");
    upsertMeta("name", "twitter:title", title);
    upsertMeta("name", "twitter:description", description);
    if (image) upsertMeta("name", "twitter:image", window.location.origin + image);

    if (jsonLd) {
      let ld = document.head.querySelector('script[data-seo-jsonld="true"]');
      if (!ld) {
        ld = document.createElement("script");
        ld.setAttribute("type", "application/ld+json");
        ld.setAttribute("data-seo-jsonld", "true");
        document.head.appendChild(ld);
      }
      ld.textContent = JSON.stringify(jsonLd);
    }
  }, [title, siteName, description, image, jsonLd]);

  return null;
}
